import type { SendSignalToFusionProps } from '~/models';

export const sendSignalToFusion = async ({
  data,
  tenant,
  globalApiUrl,
  formattedToken,
  acceptLanguage,
}: SendSignalToFusionProps) =>
  fetch(`${globalApiUrl}/applications/navigation/signal`, {
    body: JSON.stringify(data),
    headers: {
      'accept-language': acceptLanguage,
      authorization: formattedToken,
      'content-type': 'application/json',
      'x-tenant-context': tenant,
    },
    keepalive: true,
    method: 'POST',
  });
